import { LOYALTY_STATUS, LOYALTY_STEP, LOYALTY_TYPES } from '@/utils/loyalty';

export function checkIfPetUnder13Months(date: string) {
  if (!date) {
    return false;
  }

  const now = new Date();
  const birthday = new Date(date);
  const thirteenMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 13, now.getDate());
  return birthday >= thirteenMonthsAgo && birthday <= now;
}

export function checkFriendsState(
  loyalties?: Array<{ membershipType: keyof typeof LOYALTY_TYPES; marketingConsent: keyof typeof LOYALTY_STATUS }>,
) {
  const littleFriendsMembership = loyalties?.find((l) => l.membershipType === LOYALTY_TYPES.LITTLE_FRIENDS);
  const marketingConsent = littleFriendsMembership?.marketingConsent;

  switch (marketingConsent) {
    case LOYALTY_STATUS.ACTIVE:
      return LOYALTY_STEP.FRIENDS_AND_LITTLE_FRIENDS;
    case LOYALTY_STATUS.PENDING:
      return LOYALTY_STEP.FRIENDS_AND_LITTLE_FRIENDS_PENDING;
    case LOYALTY_STATUS.INACTIVE:
      return LOYALTY_STEP.FRIENDS_AND_LITTLE_FRIENDS_INACTIVE;
    default:
      return LOYALTY_STEP.FRIENDS;
  }
}
